import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['preferencesForm', 'userForm', 'userFormDelivery', 'userFormTimezone']

  // requestSubmit() dispatches a real submit event so Turbo can intercept.
  // submit() bypasses Turbo and forces a full page reload.
  preferencesToggle() {
    this.preferencesFormTarget.requestSubmit();
  }

  userUpdate() {
    this.userFormTarget.requestSubmit();
  }
}
